import { OnInit, Component } from '@angular/core';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private authService: AuthService) {}
  public authModal = false;
  ngOnInit() {
    this.authService.showAuthModal.subscribe((val: boolean) => {
      document.querySelector('body').classList.toggle('noScroll');
      this.authModal = val;
    });
  }
}
